import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUserPlanManager } from '@/shared/plan';
import { useUpsellingGuard } from '@/shared/plan';
import { EditTools } from '../../EditTools';
import { useAiChoiceListGeneration } from './useAiChoiceListGeneration';
export const AiChoiceListGenerationButton = () => {
  const {
    userPlanManager
  } = useUserPlanManager();
  const {
    generate,
    disabled
  } = useAiChoiceListGeneration();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_CHOICE_GENERATION');
  const upsellingGuard = useUpsellingGuard();
  return <WithPlanBadge planType={featurePlanType} isBadgeVisible={true} data-sentry-element="WithPlanBadge" data-sentry-component="AiChoiceListGenerationButton" data-sentry-source-file="AiChoiceListGenerationButton.tsx">
      <EditTools.AiAnswerGenerationButton disabled={disabled} onClick={() => {
      void upsellingGuard(generate, {
        feature: 'AI_CHOICE_GENERATION',
        from: 'ai'
      });
    }} data-sentry-element="unknown" data-sentry-source-file="AiChoiceListGenerationButton.tsx" />
    </WithPlanBadge>;
};